import styled from 'styled-components'
import { Button } from '@/components'

import { E_Colors } from '@/helpers/colors'


export const SC_CertificatesList = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 24px;
  flex-direction: column;
  padding-bottom: 16px;
`

export const SC_CertificateWrapper = styled.div`
  border-radius: 25px;
  background-color: ${E_Colors.GrayF2};
  padding: 16px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
`

export const SC_LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const SC_CertificateTop = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`

export const SC_CertificateOrganizationLogo = styled.div`
  padding: 5px;
  border-radius: 50%;
  background-color: ${E_Colors.White};
  flex-grow: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 28px;
    height: 28px;
    border-radius: 50%;
  }
`

export const SC_CertificateOrganizationTitle = styled.div`
  display: flex;
  flex-direction: column;

  > :first-child {
    color: ${E_Colors.TextPrimary};
    font-size: 16px;
  }

  > :last-child {
    color: ${E_Colors.Gray9C9CA1};
    font-size: 11px;
  }
`

export const SC_Denomination = styled.div`
  display: flex;
  flex-direction: column;

  > :first-child {
    color: ${E_Colors.TextPrimary};
    font-size: 22px;
    font-weight: 600;
    white-space: pre;
  }

  > :last-child {
    color: ${E_Colors.Gray9C9CA1};
    font-size: 11px;
  }
`

export const SC_RightSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-end;
  justify-content: space-between;
`

export const SC_DeleteCertificate = styled.div`
  display: flex;
  gap: 4px;
  color: ${E_Colors.EraRed};
  cursor: pointer;
`

export const SC_QR = styled.img`
  width: 75px;
  height: 75px;
  border-radius: 8px;
  cursor: pointer;
`

export const SC_BackgroundBlur = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), ${E_Colors.White});
  z-index: 0;
`

export const SC_ButtonWrapper = styled.div`
  position: sticky;
  bottom: 0;
  margin-top: auto;
  padding-top: 16px;
`

export const SC_Button = styled(Button)`
  width: 100%;
  position: relative;
  z-index: 1;
`
